import { Location } from '@angular/common';
import { Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { UpdateCostCenterPriceStateEnums } from 'src/app/enum/update-cost-center-price-enums';
import { UpdateCostCenterPriceModel } from 'src/app/models/others/update-cost-center-price.model';
import { WindowService } from 'src/app/services/authentication/window.service';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { UpdateCostCenterPriceService } from 'src/app/services/others/update-cost-center-price.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-register-update-cost-center-price',
  templateUrl: './register-update-cost-center-price.component.html',
  styleUrls: ['./register-update-cost-center-price.component.scss'],
  standalone: false
})
export class RegisterUpdateCostCenterPriceComponent implements OnInit {

  branchId: number = 0;
  disableSendButton: boolean = false;
  disabledForm: boolean = false;
  disableProcessButton: boolean = false;
  formUpdateCostCenterPrice: FormGroup = new FormGroup({});
  icon: string = '';
  isOpened: string | undefined = undefined;
  listBranches: any[] = [];
  nameWindow: string = 'Actualizar Precios Por C.Costos';
  permissionUpdatable: boolean = false;
  projectName = ProjectName.projectName;
  quantityDetails: number = 0;
  severityState: string = 'success';
  stateUpdateCostCenterPrice: string = '';
  titleState: string = '';
  updateCostCenterPriceContract: UpdateCostCenterPriceModel = new UpdateCostCenterPriceModel();
  updateCostCenterPriceId: number = 0;
  url: string = 'update-cost-center-price';

  constructor(private activatedRoute: ActivatedRoute,
    private branchService: BranchService,
    private formBuilder: FormBuilder,
    private formControlStateService: FormControlStateService,
    private headerService: HeaderService,
    private location: Location,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private updateCostCenterPriceService: UpdateCostCenterPriceService,
    private windowService: WindowService) {
    this.validateForm(new UpdateCostCenterPriceModel());
  }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    await this.getPermission();
    this.activatedRoute.params.subscribe(params => {
      this.updateCostCenterPriceId = Object.keys(params).length > 0 ? params?.id : null;
    });
    this.handleInitialState();
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  async createNewRegister() {
    if (!this.permissionUpdatable) {
      return this.toastHandlerService.showToast('warning', `El usuario no tiene permisos para
        crear actualizaciones de precios por c.costos. Comuníquese con el administrador del sistema.`);
    }
    this.resetContract();
  }

  async changeBranch(branchId: number) {
    this.branchId = branchId;
    this.resetContract();
  }

  async changeConsecutive(consecutive: number) {
    this.branchId = this.formUpdateCostCenterPrice.get("branchId")?.value;
    if (!this.branchId) {
      return this.toastHandlerService.showToast('warning', 'Seleccione una sucursal.');
    }
    if (!consecutive) {
      return this.resetContract();
    }
    try {
      const response = await firstValueFrom(this.updateCostCenterPriceService.getUpdateCostCenterPriceByKeys(this.branchId, consecutive));
      this.updateCostCenterPriceId = response.updateCostCenterPriceId;
      this.updateCostCenterPriceContract = response;
      this.validateForm(this.updateCostCenterPriceContract);
      this.location.replaceState(`/${this.url}/register/${this.updateCostCenterPriceId}`);
    } catch (error) {
      console.error('Error al buscar la actualización de precios por c.costos.', error);
    }
  }

  async createUpdateCostCenterPrice(model: UpdateCostCenterPriceModel) {
    try {
      const response = await firstValueFrom(this.updateCostCenterPriceService.createAsync(model));
      this.updateCostCenterPriceId = response.updateCostCenterPriceId;
      this.updateCostCenterPriceContract = response;
      this.validateForm(this.updateCostCenterPriceContract);
      this.location.replaceState(`/${this.url}/register/${this.updateCostCenterPriceId}`);
      this.toastHandlerService.showToast('success', `La actualización de precios por c.costos fue creada exitosamente.`);
    } catch (error) {
      console.error('Error al crear la actualización de precios por c.costos.', error);
    }
  }

  async deleteUpdateCostCenterPrice() {
    if (!this.updateCostCenterPriceId) {
      return this.toastHandlerService.showToast('warning', 'Debe crear la actualización de precios por c.costos.');
    }
    if (this.updateCostCenterPriceContract.updateCostCenterPriceState != UpdateCostCenterPriceStateEnums.open) {
      return this.toastHandlerService.showToast('warning', `La actualización de precios por c.costos esta cerrada.`);
    }
    const confirm = await Swal.fire({
      title: 'Atención',
      text: '¿Realmente desea eliminar la actualización de precios por c.costos?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí',
      cancelButtonText: 'No',
    });
    if (confirm.isConfirmed) {
      try {
        await firstValueFrom(this.updateCostCenterPriceService.deleteAsync(this.updateCostCenterPriceId));
        this.resetContract();
        this.toastHandlerService.showToast('success', 'La actualización de precios por c.costos fue eliminada exitosamente.');
      } catch (error) {
        console.error('Error al eliminar la actualización de precios por c.costos', error);
      }
    }
  }

  async getButtonClick(buttonClick: any) {
    this.branchId = this.formUpdateCostCenterPrice.get("branchId")?.value;
    if (!this.branchId) {
      return this.toastHandlerService.showToast('warning', 'Seleccione una sucursal.');
    }
    await this.handleUpdateCostCenterPriceNavigation(buttonClick, this.branchId)
  }

  async getFirstBranchByUserAuthenticated() {
    try {
      const response = await firstValueFrom(this.branchService.getFirstBranchByUserAuthenticatedAsync());
      this.branchId = response.branchId;
    } catch (error) {
      console.error('Error al obtener la sucursal del usuario.', error);
    }
  }

  async getListBranches() {
    try {
      const response = await firstValueFrom(this.branchService.getAllBranchesForSelectAsync());
      this.listBranches = response;
    } catch (error) {
      console.error('Error obtener la lista de sucursales.', error);
    }
  }

  async getUpdateCostCenterPriceById() {
    try {
      const response = await firstValueFrom(this.updateCostCenterPriceService.getByIdAsync(this.updateCostCenterPriceId));
      this.updateCostCenterPriceId = response.updateCostCenterPriceId;
      this.branchId = response.branchId;
      this.updateCostCenterPriceContract = response;
      this.validateForm(this.updateCostCenterPriceContract);
    } catch (error) {
      console.error('Error al obtener la actualización de precios por c.costos por id.', error);
    }
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast('error', `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`);
      }
    } else {
      localStorage.clear();
    }
    await Promise.all([
      this.getListBranches(),
      this.getPermissionProfileByUrl()
    ]);
  }

  async getPermissionProfileByUrl() {
    try {
      const response = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
      this.permissionUpdatable = response;
    } catch (error) {
      console.error('Error al buscar los permisos del perfil.', error);
    }
  }

  async handleInitialState() {
    if (this.updateCostCenterPriceId) {
      await this.getUpdateCostCenterPriceById();
    } else {
      await this.getFirstBranchByUserAuthenticated();
      this.createNewRegister();
    }
  }

  async handleUpdateCostCenterPriceNavigation(buttonClick: any, branchId: number) {
    const consecutive = this.formUpdateCostCenterPrice.get("consecutive")?.value;
    const actionMap: Record<string, () => Promise<UpdateCostCenterPriceModel>> = {
      first: () =>
        firstValueFrom(this.updateCostCenterPriceService.getFirstUpdateCostCenterPriceByKeys(branchId)),
      previus: () =>
        firstValueFrom(this.updateCostCenterPriceService.getPreviusUpdateCostCenterPriceByKeys(branchId, consecutive)),
      next: () =>
        firstValueFrom(this.updateCostCenterPriceService.getNextUpdateCostCenterPriceByKeys(branchId, consecutive)),
      last: () =>
        firstValueFrom(this.updateCostCenterPriceService.getLastUpdateCostCenterPriceByKeys(branchId)),
    };
    const action = actionMap[buttonClick.target.id];
    if (!action) {
      return this.resetContract();
    }
    try {
      const updateCostCenterPrice = await action();
      this.updateCostCenterPriceId = updateCostCenterPrice.updateCostCenterPriceId;
      this.updateCostCenterPriceContract = updateCostCenterPrice;
      this.validateForm(this.updateCostCenterPriceContract);
      this.location.replaceState(`/${this.url}/register/${this.updateCostCenterPriceId}`);
    } catch (error) {
      console.error(`Error al buscar la actualización de precios por c.costos (${buttonClick.target.id}).`, error);
    }
  }

  async processUpdateCostCenterPrice() {
    try {
      const response = await firstValueFrom(this.updateCostCenterPriceService.processUpdateCostCenterPrice(this.updateCostCenterPriceId));
      this.toastHandlerService.showToast('success', `La actualización de precios por c.costos fue procesada exitosamente.`);
      this.updateCostCenterPriceContract = response;
      this.validateForm(this.updateCostCenterPriceContract);
    } catch (error) {
      console.error('Error al procesar la actualización de precios por c.costos.', error);
    }
  }

  async send() {
    this.validateFormControls();
    if (this.updateCostCenterPriceContract.updateCostCenterPriceState != UpdateCostCenterPriceStateEnums.open) {
      return this.toastHandlerService.showToast('warning', `La actualización de precios por c.costos está cerrada.`);
    }
    if (!this.formUpdateCostCenterPrice.valid) {
      return this.showValidationMessages();
    }
    const modelUpdateCostCenterPrice = this.formUpdateCostCenterPrice.getRawValue() as UpdateCostCenterPriceModel;
    if (this.updateCostCenterPriceId === 0) {
      await this.createUpdateCostCenterPrice(modelUpdateCostCenterPrice);
    } else {
      await this.updatUpdateCostCenterPrice(modelUpdateCostCenterPrice);
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      branchId: {
        required: 'Debe seleccionar una Sucursal.',
        min: 'Debe seleccionar una Sucursal válida.'
      },
      updateCostCenterPriceState: {
        required: 'Debe seleccionar el Estado de Actualización.'
      },
      observation: {
        maxlength: 'La Observación no puede tener más de 250 caracteres.'
      }
    };
    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formUpdateCostCenterPrice.get(controlName);
      if (control && control.invalid && control.errors) {
        const messages = controlMessages[controlName];
        Object.keys(control.errors).forEach(errorKey => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  async resetContract() {
    this.updateCostCenterPriceId = 0;
    this.updateCostCenterPriceContract = new UpdateCostCenterPriceModel();
    this.updateCostCenterPriceContract.branchId = this.branchId;
    this.validateForm(this.updateCostCenterPriceContract);
    this.location.replaceState(`/${this.url}/register`);
  }

  updateFormState() {
    const isNewWalletManagement = this.updateCostCenterPriceId === 0;
    const controlConsecutive = this.formUpdateCostCenterPrice.controls['consecutive'];
    const state = this.updateCostCenterPriceContract.updateCostCenterPriceState;
    const isOpen = state === UpdateCostCenterPriceStateEnums.open;
    const hasDetails = this.quantityDetails !== 0;
    this.disableSendButton = !isOpen;
    this.disableProcessButton = !isOpen || isNewWalletManagement || !hasDetails;
    this.disabledForm = !isOpen || isNewWalletManagement;
    this.titleState = isOpen ? 'Cerrar' : 'Abrir';
    this.severityState = isOpen ? 'success' : 'danger';
    this.icon = isOpen ? 'pi pi-lock-open' : 'pi pi-lock';
    this.stateUpdateCostCenterPrice = isOpen ? 'Abierto' : 'Cerrado';

    setTimeout(() => {
      if (state == UpdateCostCenterPriceStateEnums.open) {
        this.formUpdateCostCenterPrice.enable();
        if (isNewWalletManagement) {
          controlConsecutive.disable();
        } else {
          controlConsecutive.enable();
        }
      } else {
        this.formUpdateCostCenterPrice.disable();
        this.formControlStateService.setControlState(
          this.formUpdateCostCenterPrice,
          ['branchId', 'consecutive'],
          true
        );
      }
      if (!this.permissionUpdatable) {
        this.formUpdateCostCenterPrice.disable();
        this.formControlStateService.setControlState(
          this.formUpdateCostCenterPrice,
          ['branchId', 'consecutive'],
          true
        );
      }
    });
  }

  async updatUpdateCostCenterPrice(model: UpdateCostCenterPriceModel) {
    this.updateCostCenterPriceContract.updateCostCenterPriceState = model.updateCostCenterPriceState;
    this.updateCostCenterPriceContract.observation = model.observation;
    try {
      const response = await firstValueFrom(this.updateCostCenterPriceService.updateAsync(this.updateCostCenterPriceContract));
      this.updateCostCenterPriceContract = response;
      this.validateForm(this.updateCostCenterPriceContract);
      this.toastHandlerService.showToast('success', `La actualización de precios por c.costos fue modificada exitosamente.`);
    } catch (error) {
      console.error('Error al modificar la actualización de precios por c.costos.', error);
    }
  }

  async validateForm(updateCostCenterPrice: UpdateCostCenterPriceModel) {
    this.formUpdateCostCenterPrice = this.formBuilder.group({
      branchId: [updateCostCenterPrice.branchId, [Validators.required]],
      consecutive: [updateCostCenterPrice.consecutive],
      updateCostCenterPriceState: [updateCostCenterPrice.updateCostCenterPriceState, [Validators.required]],
      observation: [updateCostCenterPrice.observation, [Validators.maxLength(250)]],
    });
    this.updateFormState();
  }

  validateFormControls() {
    Object.keys(this.formUpdateCostCenterPrice.controls).forEach((key) => {
      const control = this.formUpdateCostCenterPrice.get(key);
      if (control && control.invalid) {
        console.warn(
          `${key} es inválido`,
          control.errors,
          'value:',
          control.value
        );
      }
    });
  }
}
